module.exports = (__webpack_public_path__ || '') + "static/images/photo-2-339220c02ca52ca512b95f9e9a22a06d.jpg";